import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  IconButton,
  TableCell,
  TableRow
} from '@material-ui/core';
import { DataMappingIcon } from 'components/CustomSVG';
import {
  getRPAChargeCodesMappedApi,
  updateRPAChargeMappedProductApi
} from 'api';
import CustomizeButton from '../ActionButtons/CustomizeButton';
import EditButton from '../ActionButtons/EditButton';
import ChangeMappingModal from '../ChangeMapping/ChangeMappingModal';
import DataMappingEditModal from './DataMappingEditModal';


const DataMappingTableRow = ({
  chargeCode,
  headTableCells,
  sort,
  search,
  filters,
  currentPage,
  rowsPerPage
}) => {
  const dispatch = useDispatch();
  const {
    name,
    product,
  } = chargeCode;
  const [openMappingModal, setOpenMappingModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);

  const columns = headTableCells.reduce((acc, column) => {
    acc[column.label] = column;
    return acc;
  }, {});

  const handleUpdateMappedItem = async ({chargeProductData}) => {
    const {
      catalogName,
      sku,
      revenueCategory1,
      revenueCategory2,
      revenueCategory3,
      revenueCategory4,
      replenishment,
      cost,
      catalogBrand,
      manufacturer,
      loyaltyProgram
    } = chargeProductData;

    //Do not send chargeName for update. TODO: can be sent after API will be fixed
    const mappedData =   {
      sku,
      cost,
      manufacturer,
      brand: catalogBrand,
      replenishment,
      category1: revenueCategory1,
      category2: revenueCategory2,
      category3: revenueCategory3,
      category4: revenueCategory4,
      loyalty_program: loyaltyProgram,
      catalog_name: catalogName
    };

    const isChargeMapped = await updateRPAChargeMappedProductApi({dispatch, id: product.id, mappedData});

    if (isChargeMapped) {
      getRPAChargeCodesMappedApi({
        dispatch,
        sort,
        search,
        filters,
        currentPage,
        rowsPerPage
      });

      if (openMappingModal) {
        setOpenMappingModal(false);
      } else if (openEditModal) {
        setOpenEditModal(false);
      }
    }
  };

  return (
    <TableRow>
      <TableCell
        className={`${columns['Practice Management Charge Description']?.display ? '' : 'hidden'}`}
      >
        {name}
      </TableCell>
      <TableCell
        className={`${columns['Product Name']?.display ? '' : 'hidden'}`}
      >
        {product.catalog_name}
      </TableCell>
      <TableCell
        className={`${columns['Change Mapping']?.display ? '' : 'hidden'}`}
        align="center"
      >
        <IconButton
          className="border-radius-8 p-2"
          onClick={() => setOpenMappingModal(true)}
          title="Change Mapping"
        >
          <DataMappingIcon />
        </IconButton>
        {openMappingModal &&
          <ChangeMappingModal
            chargeName={name}
            open={openMappingModal}
            setOpen={setOpenMappingModal}
            onConfirm={handleUpdateMappedItem}
          />
        }
      </TableCell>
      <TableCell
        className={`${columns['SKU']?.display ? '' : 'hidden'} whitespace-no-wrap`}
      >
        {product.sku}
      </TableCell>
      <TableCell
        className={`${columns['Revenue Category 1']?.display ? '' : 'hidden'}`}
      >
        <EditButton handleClick={() => setOpenEditModal(true)} />
        <span>{product.category1}</span>
        {openEditModal &&
          <DataMappingEditModal
            chargeName={name}
            productData={product}
            open={openEditModal}
            setOpen={setOpenEditModal}
            onConfirm={handleUpdateMappedItem}
          />
        }
      </TableCell>
      <TableCell
        className={`${columns['Revenue Category 2']?.display ? '' : 'hidden'}`}
      >
        {product.category2}
      </TableCell>
      <TableCell
        className={`${columns['Revenue Category 3']?.display ? '' : 'hidden'}`}
      >
        {product.category3}
      </TableCell>
      <TableCell
        className={`${columns['Revenue Category 4']?.display ? '' : 'hidden'}`}
      >
        {product.category4}
      </TableCell>
      <TableCell
        className={`${columns['Brand']?.display ? '' : 'hidden'}`}
      >
        {product.brand}
      </TableCell>
      <TableCell
        className={`${columns['Manufacturer']?.display ? '' : 'hidden'}`}
      >
        {product.manufacturer}
      </TableCell>
      <TableCell
        className={`${columns['Loyalty Program']?.display ? '' : 'hidden'}`}
      >
        {product.loyalty_program}
      </TableCell>
      <TableCell
        className={`${columns['Action']?.display ? '' : 'hidden'}`}
      >
        <CustomizeButton />
      </TableCell>
    </TableRow>
  );
};

export default DataMappingTableRow;
